"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        barcode: 'UNICORN',
        goods: 'Clothing',
        height: '20|cm',
        id: 1,
        label: 'http://some.location/labels/1.png',
        length: '20|cm',
        merchantId: 1,
        productId: 1,
        recipientId: 1,
        senderId: 1,
        timeSlotId: 1,
        trunkrsNr: 1,
        weight: '1|kg',
        width: '20|cm',
    },
    {
        barcode: 'KANGAROO',
        goods: 'Clothing',
        height: '20|cm',
        id: 2,
        label: 'http://some.location/labels/2.png',
        length: '20|cm',
        merchantId: 1,
        productId: 1,
        recipientId: 2,
        senderId: 1,
        timeSlotId: 1,
        trunkrsNr: 2,
        weight: '1|kg',
        width: '20|cm',
    },
    {
        barcode: 'KOALA',
        goods: 'Clothing',
        height: '20|cm',
        id: 3,
        label: 'http://some.location/labels/3.png',
        length: '20|cm',
        merchantId: 1,
        productId: 1,
        recipientId: 3,
        senderId: 1,
        timeSlotId: 1,
        trunkrsNr: 3,
        weight: '1|kg',
        width: '20|cm',
    },
    {
        barcode: 'GIRAFFE',
        goods: 'Clothing',
        height: '20|cm',
        id: 4,
        label: 'http://some.location/labels/4.png',
        length: '20|cm',
        merchantId: 1,
        productId: 1,
        recipientId: 4,
        senderId: 1,
        timeSlotId: 1,
        trunkrsNr: 4,
        weight: '1|kg',
        width: '20|cm',
    },
    {
        barcode: 'PURPLE-BIRD',
        goods: 'Clothing',
        height: '20|cm',
        id: 5,
        label: 'http://some.location/labels/5.png',
        length: '20|cm',
        merchantId: 1,
        productId: 1,
        recipientId: 5,
        senderId: 1,
        timeSlotId: 1,
        trunkrsNr: 5,
        weight: '1|kg',
        width: '20|cm',
    },
];
